import { Routes } from '@angular/router';
import { MainContainerPageComponent } from './main-container-page.component';
import { HOME_PAGE_SEO, TOOL_PAGES, toolPageSeo } from '../../pages/tool-pages.config';

export const MAIN_CONTAINER_PAGE_ROUTES: Routes = [
  {
    path: '',
    component: MainContainerPageComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('../../pages/home-page').then(m => m.HomePageComponent),
        data: { seo: HOME_PAGE_SEO },
      },
      ...TOOL_PAGES.map(tool => ({
        path: tool.slug,
        loadComponent: () => import('../../pages/tool-page').then(m => m.ToolPageComponent),
        data: { tool, seo: toolPageSeo(tool) },
      })),
    ],
  },
];
